import { Directive, HostBinding, HostListener, Input, TemplateRef, ViewContainerRef, inject, output } from '@angular/core';

@Directive({
  selector: '[cdkDetailRow]',
  standalone: false,
})
export class CdkDetailRowDirective {
  vcRef = inject(ViewContainerRef);

  private row: any;
  private tRef: TemplateRef<any>;
  private opened: boolean;

  public detailRowClick = output<void>();

  @HostBinding('class.expanded')
  get expanded(): boolean {
    return this.opened;
  }

  @Input()
  set cdkDetailRow(value: any) {
    if (value !== this.row) {
      this.row = value;
    }
  }

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('cdkDetailRowTpl')
  set template(value: TemplateRef<any>) {
    if (value !== this.tRef) {
      this.tRef = value;
    }
  }

  @HostListener('click')
  onClick(): void {
    this.toggle();
    this.detailRowClick.emit();
  }

  toggle(): void {
    if (this.opened) {
      this.vcRef.clear();
    } else {
      this.render();
    }
    this.opened = this.vcRef.length > 0;
  }

  private render(): void {
    this.vcRef.clear();
    if (this.tRef && this.row) {
      this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
    }
  }
}
